import React, { useEffect } from "react";
import { Container } from "./Section.styled";
import { useInView } from "react-intersection-observer";
import { usePageContextFunction } from "../../../context/PageContext";
import { useParams } from "react-router-dom";
import { func } from "../../../utils";
import useWindowSize from "../../../hooks/useWindowSize";

const Section = ({
  children,
  id,
  display,
  alignItems,
  height,
  scrollSnap,
  position,
  backgroundColor,
  background,
  overflowX,
  overflowY,
  padding,
  className,
  rootMargin,
}) => {
  const { city } = useParams();
  // rootMargin lets a page narrow the "in view" band (e.g. press-con passes a
  // top strip so only the section at the top of the viewport is active, instead
  // of every short section that happens to be visible). Default = full viewport.
  const { ref, inView } = useInView({
    threshold: 0,
    rootMargin,
  });

  const { size } = useWindowSize();
  const isMobileView = (size?.width || 0) <= 768;
  const bgPath = "/bg/bg-home-detail.jpg";

  const { setIdInView, setActiveColor } = usePageContextFunction();
  useEffect(() => {
    if (id.includes("pertandingan") || id.includes("lokasi")) {
      // Gambarnya no-repeat dengan tinggi terbatas (2983px), jadi list jadwal
      // yang panjang bakal lewat dari gambarnya. Warna dasar ini disamain sama
      // bagian bawah gambar biar sisanya nyambung gelap, bukan putih.
      return setActiveColor(`#012F48 url(${func.getStaticImg(bgPath)})`);
    }
    //  else if (id.includes("lokasi")) {
    //   if (city === "soc") {
    //     return setActiveColor(`linear-gradient(
    //       to bottom,
    //       #274364 20%,
    //       #274364 50%)`);
    //   }
    // }
    else {
      //     return setActiveColor(`url(${func.getStaticImg("/bg/bg-talent.jpg")})`);
      return setActiveColor(`linear-gradient(
          to bottom,
          #fff 20%,
          #fff 50%)`);
    }

    setActiveColor("#fff");
  }, [id, bgPath]);

  useEffect(() => {
    if (inView) {
      setIdInView(id);
    }
  }, [inView, id]);

  return (
    <Container
      ref={ref}
      id={id}
      alignItems={alignItems}
      display={display}
      height={height}
      scrollSnap={scrollSnap}
      position={position}
      backgroundColor={backgroundColor}
      background={background}
      overflowX={overflowX}
      overflowY={overflowY}
      padding={padding}
      className={className}
    >
      {children}
    </Container>
  );
};

export default Section;
